module.exports = __webpack_public_path__ + "static/media/join.13b4f90e.jpg";